import _ from 'lodash';
import AppService from 'App/legacy/AppService';

// Return true or false if the user can see the category
const hasRoleAccess = function (self, product) {
	// If user is admin we can use all products OR
	// If roles is empty everyone can use this product OR
	if (self.administrator || !product.roles || !product.roles.length) {
		return true;
	}
	const myRoleId = self.role ? self.role.id : null;
	// If my role is in array we are all good
	if (myRoleId && _.find(product.roles, { id: myRoleId })) {
		return true;
	}
	// If we get to this we cannot use this product, sorry
	return false;
};

const parseProduct = product => {
	const self = AppService.getSelf();

	product.$hasAccess = hasRoleAccess(self, product);

	return product;
};

export default parseProduct;
